import { Injectable } from '@angular/core';
import { httpsCallable, snapshot } from '@principle-theorem/shared';
import {
  type ICreatePaymentIntentRequest,
  type ICreatePaymentIntentResponse,
  type IStripeConnectRedirectRequest,
  type IStripeConnectRedirectResponse,
} from '@principle-theorem/stripe';

@Injectable()
export class StripeFunctions {
  async createPaymentIntent(
    orgUid: string,
    amount: number
  ): Promise<ICreatePaymentIntentResponse> {
    return snapshot(
      httpsCallable<ICreatePaymentIntentRequest, ICreatePaymentIntentResponse>(
        'http-stripe-createPaymentIntent'
      )({ amount, orgUid, clientCapability: 'direct-charge' })
    );
  }

  async connectRedirect(
    orgUid: string
  ): Promise<IStripeConnectRedirectResponse> {
    return snapshot(
      httpsCallable<
        IStripeConnectRedirectRequest,
        IStripeConnectRedirectResponse
      >('http-stripe-connectRedirect')({ orgUid })
    );
  }
}
